import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { FullPageContainer } from '../styled'
import { countAnswered } from './helpers'
import AssessmentHeader from './AssessmentHeader'
import ProgressBar from './ProgressBar'
import QuestionItem from './QuestionItem'
import { ScrollArea, ErrorText, MutedText, SubmitButton } from './styles'

function ActiveScreen({
  assessment,
  answers,
  timeLeft,
  isSubmitting,
  validationError,
  uploadingCount,
  onAnswerChange,
  onUploadingState,
  onSubmit,
}) {
  const { t } = useTranslation()
  const questions = assessment?.questions || []
  const answeredCount = countAnswered(answers)

  return (
    <FullPageContainer>
      <AssessmentHeader assessment={assessment} timeLeft={timeLeft} />

      {/* Visible scrollbar for the active question area */}
      <ScrollArea>
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <ProgressBar
                answeredCount={answeredCount}
                total={questions.length}
              />

              {questions.map((q, idx) => (
                <QuestionItem
                  key={q.id}
                  index={idx}
                  question={q}
                  value={answers[q.id]}
                  onChange={(val) => onAnswerChange(q.id, val)}
                  onUploading={onUploadingState}
                />
              ))}

              <div className="d-flex flex-column align-items-end mt-4 pb-4">
                {validationError && (
                  <ErrorText className="mb-2">{validationError}</ErrorText>
                )}
                {uploadingCount > 0 && (
                  <MutedText className="mb-2">
                    {t('assessment.uploading')}...
                  </MutedText>
                )}
                <SubmitButton
                  width="240px"
                  height="50px"
                  onClick={() => onSubmit()}
                  disabled={isSubmitting || uploadingCount > 0}
                >
                  {isSubmitting
                    ? t('general.loading')
                    : t('assessment.submitAssessment')}
                </SubmitButton>
              </div>
            </div>
          </div>
        </div>
      </ScrollArea>
    </FullPageContainer>
  )
}

ActiveScreen.propTypes = {
  assessment: PropTypes.shape({
    questions: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  answers: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.shape({}),
    ]),
  ).isRequired,
  timeLeft: PropTypes.number,
  isSubmitting: PropTypes.bool,
  validationError: PropTypes.string,
  uploadingCount: PropTypes.number,
  onAnswerChange: PropTypes.func.isRequired,
  onUploadingState: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default ActiveScreen
